// infoButton.js
import React from 'react';

// Base64 strings for the graph icons
const infoIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAxOTIuOCAxOTIuOCc+PGNpcmNsZSBjeD0nOTYuNCcgY3k9Jzk2LjQnIHI9JzkxLjQnIHN0eWxlPSdmaWxsOiAjMTkxZjJkOyBzdHJva2U6ICNmZmY7IHN0cm9rZS1taXRlcmxpbWl0OiAxMDsgc3Ryb2tlLXdpZHRoOiAxMHB4OycvPjxwYXRoIGQ9J005NC4yMiw0MC41NWM3LjIsMCwxMi45Niw1Ljc2LDEyLjk2LDEyLjk2cy01Ljc2LDEyLjc4LTEyLjk2LDEyLjc4LTEyLjc4LTUuNTgtMTIuNzgtMTIuNzgsNS41OC0xMi45NiwxMi43OC0xMi45NlptLTExLjM0LDMyLjk0aDIyLjg2djcyaC0yMi44NlY3My40OVonIHN0eWxlPSdmaWxsOiAjZmZmOyBzdHJva2U6ICMwMDA7IHN0cm9rZS1taXRlcmxpbWl0OiAxMDsnLz48L3N2Zz4=';

const InfoButton = ({showInfo}) => (
  <div className='inlineToggle' style={{ cursor: 'pointer', width: '24px', height: '24px' }} onClick={showInfo}>
    <img
      src={infoIcon}
      alt="Info Button"
      style={{ width: '100%', height: '100%' }}
    />
  </div>
);

export default InfoButton;
